import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { withTranslation } from "react-i18next";
import SidebarContent from "./sidebarContent";

/**
 * Renders the sidebar component.
 * @param {Object} props - The props passed to the component.
 * @returns {JSX.Element} - The rendered sidebar component.
 */
const Sidebar = (props) => {
  return (
    <>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </>
  );
}

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps,{})(withTranslation()(Sidebar));
